const sampleAssessmentData = {
  _id: "6827356e0c846093345f287e",
  answer_paper_id: "542f8ac2-1ee4-4029-b8e1-18b3525d3530",
  candidate_id: "218d8787-416b-4b81-ab05-28a14c52c5f4",
  assessment_id: "d8ed408c-b2f1-4fbc-a037-9199dc9dd484",
  candidate_info: {
    first_name: "Sonia",
    last_name: "Bloom",
    name: "Sonia Bloom",
    email: "abhishek@digikore.com",
    department: "",
    current_role: "Senior Sales Executive",
    job_title: "Senior Sales Executive",
    job_description:
      "Sales of Cloud Software to B2B customers in Europe and Asia. As Senior Sales Executive my job is to secure new business by cold calling and upselling to existing customers. ",
    assessment_date: "2025-05-16T12:51:00.522000",
    assessment_duration_minutes: 60,
  },
  development_recommendations: [
    "To improve accountability, start by setting small, achievable goals each week and track your progress; celebrate your successes to build confidence in your ability to follow through.",
    "Enhance your creativity by dedicating time each day to brainstorm ideas without judgment; try free writing or mind mapping to explore different perspectives and solutions.",
    "Build thick skin by seeking constructive feedback from trusted colleagues or friends; practice viewing criticism as a valuable opportunity for growth and improvement.",
  ],
  hr_id: "",
  manager_email: "",
  manager_id: "fb44f450-e40c-4bb3-908a-b505d1957e7e",
  manager_tips: [
    "Schedule regular one-on-one check-ins to discuss progress on projects and hold them accountable for their tasks, while also encouraging them to share any challenges they face.",
    "Encourage creativity by setting aside time for brainstorming sessions where they can freely share ideas without judgment, fostering an environment that values innovative thinking.",
    "Provide constructive feedback in a supportive manner and help them develop a plan for resilience by discussing past experiences, emphasizing the importance of learning from mistakes and criticisms.",
  ],
  processing_duration_seconds: 77.44695,
  promotion_readiness: {
    summary:
      "Sonia Bloom shows some potential for a more senior role, particularly in adaptability and problem-solving, but her low scores in goal orientation, resilience, and accountability indicate significant areas for development. Focusing on enhancing her drive and team collaboration skills will be essential for her to be fully ready for promotion.",
  },
  role_fit_analysis: {
    current_role_fit_score: 5.0,
    current_role_fit_insight:
      "Sonia has a moderate fit for the Senior Sales Executive role, but her lower scores in goal orientation and resilience may hinder her ability to effectively secure new business and handle the pressures of sales.",
    suggested_roles: [
      {
        role: "Customer Success Manager",
        fit_score: 7.0,
        insight:
          "In this role, Sonia's empathy and relationship-driven approach can shine, helping to nurture existing customer relationships and ensure their satisfaction.",
      },
      {
        role: "Sales Support Specialist",
        fit_score: 6.5,
        insight:
          "This position would allow Sonia to leverage her problem-solving and communication skills while providing valuable support to the sales team without the high-pressure demands of direct sales.",
      },
    ],
  },
  status: "Completed",
  submitted_date: "2025-05-16T12:51:00.522000",
  summary:
    "Sonia Bloom presents as a thoughtful individual with a moderate level of empathy and active listening skills, allowing her to connect with others on a personal level. While she exhibits a good degree of adaptability and problem-solving capabilities, her lower scores in goal orientation and resilience may pose challenges, especially in high-pressure environments like sales. Sonia's communication skills are decent, which can help her navigate conversations effectively, though her tendency to avoid confrontation and lower confidence may affect her assertiveness in pursuing aggressive sales targets.\n\nIn a team setting, Sonia's relationship-driven nature can foster a supportive atmosphere, though her lower scores in teamwork and accountability suggest she may prefer to work independently or in less competitive environments. To thrive, she may benefit from developing stronger resilience and accountability, which will empower her to tackle challenges head-on and enhance her goal-setting abilities. Overall, while Sonia has the potential to contribute positively to a team with her interpersonal skills, a focus on personal growth in specific areas will be essential for her to excel in a senior sales role.",
  team_fit: {
    strengths: ["Adaptability", "Confidence", "Problem Solving Skills"],
    working_style:
      "Sonia tends to approach tasks with a flexible mindset, often finding practical solutions to challenges while maintaining a steady level of confidence.",
    ideal_environment:
      "She thrives in a supportive team where open communication is encouraged, allowing her to collaborate effectively and adapt to changing circumstances.",
    risks: ["Accountability", "Creativity"],
  },

  traits: [
    {
      trait: "Accountability",
      score: 4.67,
      insight:
        "This candidate may struggle to take responsibility for their actions, often leaning towards blaming external factors when things go wrong, and might not always follow through on commitments or promises made to others.",
    },
    {
      trait: "Adaptability",
      score: 5.98,
      insight:
        "This candidate shows a fair level of adaptability, often able to adjust to new situations and changes, but may occasionally struggle when faced with unexpected challenges or rapid shifts...",
    },
    {
      trait: "Communication",
      score: 5.28,
      insight:
        "The candidate tends to express their ideas clearly but may not always engage in lively discussions...",
    },
    {
      trait: "Confidence",
      score: 5.65,
      insight:
        "This candidate shows a moderate level of confidence; they are comfortable expressing their ideas and taking initiative...",
    },
    {
      trait: "Creativity",
      score: 4.73,
      insight:
        "This candidate tends to stick to familiar methods and routines, often preferring tried-and-true solutions...",
    },
    {
      trait: "Empathy & Active Listening",
      score: 5.17,
      insight:
        "This candidate tends to show a fair level of understanding and consideration for others' feelings...",
    },
    {
      trait: "Goal Orientation & Drive",
      score: 4.86,
      insight:
        "This candidate tends to take a more relaxed approach to their tasks, often waiting for direction rather than actively seeking out goals...",
    },
    {
      trait: "Optimism",
      score: 5.14,
      insight:
        "With a moderate level of optimism, this candidate tends to see the brighter side of situations but may also recognize and acknowledge challenges...",
    },
    {
      trait: "Pressure Handling",
      score: 5.04,
      insight:
        "This candidate tends to manage pressure reasonably well, often remaining calm and focused in challenging situations...",
    },
    {
      trait: "Problem Solving Skills",
      score: 5.34,
      insight:
        "The candidate demonstrates a fair ability to tackle challenges, often approaching problems with a mix of creativity and practicality...",
    },
    {
      trait: "Relationship Driven",
      score: 5.26,
      insight:
        "This candidate values relationships and enjoys connecting with others, but they may not always prioritize social interactions over tasks...",
    },
    {
      trait: "Resilience & Persistence",
      score: 4.96,
      insight:
        "This candidate may struggle to bounce back after setbacks and might give up more easily when faced with challenges...",
    },
    {
      trait: "Team Player",
      score: 4.99,
      insight:
        "This candidate may prefer working independently and might not always prioritize collaboration with others...",
    },
    {
      trait: "Thick Skin",
      score: 4.82,
      insight:
        "This candidate may find it challenging to handle criticism and often takes feedback personally...",
    },
    {
      trait: "Time Management",
      score: 5.2,
      insight:
        "This candidate tends to balance their tasks reasonably well but may sometimes struggle with prioritizing or sticking to a strict schedule...",
    },
  ],

  updated_at: "2025-05-16T12:54:05.758000",
  email_last_attempted_at: "2025-05-16T12:54:18.254000",
  email_notification_status: "sent",
};

export default sampleAssessmentData;
